import React from "react";
import { FiX } from "react-icons/fi";
import { getCustomerSession } from "../../utils/applyFlowSession";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png";

const MobileBreRejectPage = ({ setScreen }) => {
  const stored = getCustomerSession() || {};

  const mobileBre =
    stored?.bureauMobileBre ||
    stored?.bureau_mobile_bre ||
    {};

  const decision =
    mobileBre?.final_decision?.Decision ||
    mobileBre?.data?.final_decision?.Decision ||
    "";

  const reason =
    mobileBre?.final_decision?.DecisionReason ||
    mobileBre?.data?.final_decision?.DecisionReason ||
    "Your application does not meet the current eligibility criteria.";

  const formatReason = (value) => {
    return String(value || "")
      .replace(/_/g, " ")
      .replace(/\s+/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .trim();
  };

  return (
    <section className="fw-screen fw-screen--status fw-screen--rejected fw-fade">

      <div className="fw-brandmain">
        <img
          src={fundwalelogo}
          alt="Fundswalle"
          className="fw-brand__logo1"
        />
      </div>

      <div className="fw-approved">

        {/* Reject Icon */}
        <div className="fw-approved__hero fw-approved__hero--reject">
          <span className="fw-approved__icon fw-approved__icon--reject">
            <FiX />
          </span>
        </div>

        <h2 className="fw-approved__title fw-approved__title--reject">
          Application Not Approved
        </h2>

        <p className="fw-approved__msg fw-approved__msg--reject">
          We&apos;re sorry, but we&apos;re unable to proceed with
          your loan application at this time.
        </p>

        {/* BRE Reason */}
        <div className="fw-rejection-reason">
          <div className="fw-rejection-reason__label">
            Reason
          </div>

          <div className="fw-rejection-reason__title">
            Credit verification criteria not met
          </div>

          <div className="fw-rejection-reason__detail">
            {formatReason(reason)}
          </div>
        </div>

        <span className="fw-approved__chip fw-approved__chip--reject">
          Application not approved
        </span>

      </div>

      <div className="fw-screen__footer fw-approved__footer">

        <button
          type="button"
          className="fw-btn fw-btn--dark fw-btn--full"
          onClick={() => setScreen("/apply-new/landing")}
        >
          Back
        </button>

      </div>

    </section>
  );
};

export default MobileBreRejectPage;